// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"09b66d62","12":"ff3b506f","71":"02c46abe","214":"189a4bcf","248":"ae6ce162","375":"1b5585c5","454":"7ef9e38a","640":"9a88cb10","777":"fad2d166","782":"1ac0c7db"}[chunkId] + ".js";
};